import React, { useEffect } from 'react';
import { Link } from 'gatsby';
import styled, { css } from 'styled-components';
import { Box, Flex } from '../UIKit/system';
import Cookies from 'js-cookie';
import mq from '../../utils/mq';
import parseStoryblokLink from '../../utils/parse-storyblok-link';
import Container from '../container';

const Wrapper = styled(Flex)`
  width: 100%;
  background-color: #161616;

  ${mq.mobile(css`
    display: none;
  `)};
`;

const FlashLink = styled(Link)`
  color: #fff;
  font-size: 14px;
  line-height: 16px;
  margin-right: 20px;
  text-decoration: none;

  &:last-of-type {
    margin-right: 0;
  }
`;

const NewsLabel = styled.span`
  margin-right: 5px;
  color: var(--Foreground-fg-secondary-inverse, #a8a8a8);
`;

const ReadNowLabel = styled.span`
  margin-left: 5px;
  color: #fff;
  text-decoration: underline;
  text-underline-offset: 3px;
`;

const TopBar = ({ content }) => {
  if (!content) return null;

  const to = parseStoryblokLink(content.link);

  return (
    <Wrapper position={'relative'} zIndex={2} height={48} width={'100%'}>
      <Container large>
        <Flex height={48} justifyContent={'center'} alignItems={'center'}>
          <FlashLink title={content.title} to={to}>
            <NewsLabel>News:</NewsLabel> {content.title}{' '}
            <ReadNowLabel>Read now</ReadNowLabel>
          </FlashLink>
        </Flex>
      </Container>
    </Wrapper>
  );
};

export default TopBar;
